import api from '../api';

export async function getChatsForCurrentUser() {
  const response = await api.get('/chats');
  return response.data;
}

export async function getChatById(chatId) {
  const response = await api.get(`/chats/${chatId}`);
  return response.data;
}

export async function getChatByOtherUserId(otherUserId) {
  const response = await api.get(`/chats/user/${otherUserId}`);
  return response.data;
}

export async function getChatMembers(chatId) {
  const response = await api.get(`/chats/${chatId}/members`);
  return response.data;
}

export async function createChat(type, memberIds) {
  const response = await api.post(`/chats`, {
    type,
    memberIds
  });
  return response.data;
}

export async function createGroupChat(memberIds, groupName, groupImageUrl) {
  const response = await api.post(`/chats`, {
    type: 'Group',
    memberIds,
    groupName,
    groupImageUrl
  });
  return response.data;
}

export async function markChatAsRead(chatId) {
  const response = await api.post(`/chats/${chatId}/mark-read`);
  return response.data;
}

export async function getMessages(chatId, limit = 50, skip = 0) {
  const response = await api.get(`/messages/${chatId}`, {
    params: { limit, skip }
  });
  return response.data;
}

export async function sendMessage(chatId, senderId, text, tempMessageId) {
  const response = await api.post(`/messages`, {
    chatId,
    senderId,
    text,
    messageCorrelationId: tempMessageId
  });
  return response.data;
}

export async function getUnreadCount(chatId, userId, lastReadAt) {
  const response = await api.get(`/messages/${chatId}/unread`, {
    params: { userId, lastReadAt }
  });
  return response.data.unreadCount;
}